<template>
  <v-container
    id="aviso-form"
    fluid
    tag="section"
  >
    <usuario-nao-identificado-form
      v-if="!usuarioIdentificado"
      :titulocard="$t('aviso')"
    />
    <base-material-card
      :title="aviso.titulo"
      icon="mdi-message"
      color="primary"
      header
      header-classes="text-h5 font-weight-bold white--text"
    >
      <v-row>
        <v-container
          v-if="loading"
          fluid
          class="d-flex flex-column align-center justify-center"
          style="height: 100px; width: 100px; background-color: rgba(255, 255, 255, 0.7); border-radius: 8px;"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="50"
            width="7"
          />
          <span class="progress-title">Carregando...</span>
        </v-container>
        <v-col
          v-else
          cols="12"
        >
          <v-card
            outlined
            class="ma-2"
          >
            <v-card-text>
              <span v-html="avisoTexto" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import utils from '../../../services/utils'
  import avisosService from '../../../services/avisosservice'

  export default {
    name: 'DashboardFormsAvisos',
    components: {
      UsuarioNaoIdentificadoForm: () => import('./UsuarioNaoIdentificadoForm'),
    },
    mixins: [utils],
    props: {
      exibedialog: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        idAviso: 0,
        idProdutor: 0,
        aviso: {},
        usuarioIdentificado: true,
        appOnline: navigator.onLine,
        loading: false,
        avisoTexto: '',
      }
    },
    watch: {
      '$route.params.IdAviso': {
        handler (newVal) {
          if (newVal !== undefined) {
            this.idAviso = newVal.idAviso
            this.idProdutor = newVal.produtorId
            this.loadAviso(this.idAviso)
          }
        },
        immediate: true,
      },
    },
    created () {
      this.loadAviso(this.$route.params.idAviso, this.$route.params.produtorId)
    },
    beforeRouteUpdate (to, from, next) {
      this.idAviso = 0
      this.idAviso = to.params.idAviso
      this.idProdutor = to.params.produtorId
      next()
    },
    methods: {
      async loadAviso (id, idProdutor) {
        this.loading = true

        try {
          await avisosService.getAviso(id, idProdutor).then(resposta => {
            const data = resposta.data.aviso

            if (data !== null) {
              this.aviso = data

              this.avisoTexto = this.convertUrlsToLinks(this.aviso.texto)
            } else if (resposta.data.length > 0) {
              this.aviso = resposta.data[0]
              this.avisoTexto = this.convertUrlsToLinks(this.aviso.texto)
            } else {
              this.aviso = {}
              this.avisoTexto = ''
            }
          }).catch(e => {
            console.error('Erro ao buscar avisos:', e)
            this.loading = false
            this.aviso = {}
            this.avisoTexto = ''
          })
        } finally {
          this.loading = false
        }
      },
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      convertUrlsToLinks (text) {
        const urlRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+~#?&//=]*)/g

        return text.replace(urlRegex, function (url) {
          return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
        })
      },

    },
  }
</script>

<style scoped>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
.format-text {
  font-size: 12px !important;
}
#btn_confirmar {
  padding-left: 2px;
}
#analise {
  font-weight: bold;
}
.custom-color {
  color: rgb(218, 22, 22);
  text-transform: none;
  height: 5px !important;
  width: 5px !important;
  border-radius: 5px !important;
  margin-top: 13px !important;
  padding: 16px 50px !important;
}
.button-ciencia {
  text-transform: none;
  margin-top: 13px !important;
  height: 5px !important;
  width: 15px !important;
}
.v-sheet .v-toolbar__content .v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab),
.v-sheet .v-toolbar__content .v-btn.v-size--large:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 15px 18px !important;
  border-radius: 10px !important;
}
.custom-button:hover {
  background-color: #d6d1d1 !important;
}
.progress-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}
</style>
